import React from 'react'
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: 277,
    backgroundColor: "#f3f6f9",
    height: "37px",
    margin: "0 10px 17px",
    borderRadius: "4px",
    border: "solid 1px #ccd6e3",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      margin: 0,
    },
  },
  input: {
    marginLeft: 8,
    flex: 1,
    lineHeight: "2em",
    color: "#3f4355",
  },
  iconButton: {
    padding: 10,
  },
}));

const useStylesMobile = makeStyles({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginBottom: "15px",
    backgroundColor: "#f3f6f9",
  },
  input: {
    marginLeft: 8,
    flex: 1,
    lineHeight: "2em",
  },
  iconButton: {
    padding: 10,
  },
});

export const Search = (props) => {
  const sm = useStylesMobile();
  const lg = useStyles();
  const searchClasses = props.isMobile ? sm : lg;

  const {
    handleSearchInput,
    placeholder = "",
    ariaLabel = "",
    width = 277,
    value = undefined,
  } = props;

  const inputProps = {
    ...(value !== undefined && { value }),
  };

  if (inputProps.value === null) {
    inputProps.value = "";
  }

  return (
    <>
      <Paper
        className={searchClasses.root}
        style={{ width: width }}
        elevation={0}
      >
        <IconButton className={searchClasses.iconButton} aria-label={ariaLabel}>
          <SearchIcon />
        </IconButton>
        <InputBase
          className={searchClasses.input}
          placeholder={placeholder}
          inputProps={{ "aria-label": ariaLabel }}
          onChange={handleSearchInput}
          {...inputProps}
        />
      </Paper>
    </>
  );
};
